export default {"src":"/_next/static/media/ico-close.3f6293bf.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};